module.exports = ({ type, ticker, slug }) => {
    if (slug) {
        switch (type.toLowerCase()) {
            case "article":
            case "articles":
                return `/article/${slug}`
            case "question":
            case "questions":
            case "q&a":
                return `/question/${slug}`
        }
    } else {
        switch (type.toLowerCase()) {
            case "overview":
                return `/stock/${ticker.toLowerCase()}`
            case "article":
            case "articles":
                return `/stock/${ticker.toLowerCase()}/articles`
            case "question":
            case "questions":
            case "q&a":
                return `/stock/${ticker.toLowerCase()}/questions`
            case "valuation":
                return `/stock/${ticker.toLowerCase()}/valuation`
            case "timeline":
                return `/stock/${ticker.toLowerCase()}/timeline`
        }
    }
}
